import baseAPI from "@/http";

const router = "api/pergunta/perguntaevidencia";

export const evidenceQuestionAPI = {
  update: (pergunta) => baseAPI.put(router, pergunta),
  delete: (perguntaId) => baseAPI.delete(`${router}/${perguntaId}`, perguntaId),
  deleteEvidence: (perguntaId) =>
    baseAPI.delete(`${router}/excluir-evidencia/${perguntaId}`),

  download: (id) => {
    // Sempre consultar o backend: ele prioriza o arquivo armazenado e usa URL apenas como fallback.
    return baseAPI.post(`/api/arquivo/evidencia/download/${id}`, null, {
      responseType: "blob",
    });
  },
  finalizarAnalise: (perguntas) =>
    baseAPI.put(`${router}/finalizar-evidencia`, perguntas),
};
